import * as dataHelper from './dataHelper';
import * as appHelper from './appHelper';
import * as kpiModels from '../models/kpiModels';
import * as objectConstants from '../constants/objectConstants';
import * as localStorage from '../localStorage/localStorage';
import _ from 'lodash';

//KPIs

export function getPrimaryKpi(kpis) {
    const kpi = kpis.filter(kpi => kpi.is_primary);
    if (kpi) return kpi[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function setKpiRenderOrder(kpis) {
    let isEven = dataHelper.isEven(kpis);
    let primaryIndex = getPrimaryKpiIndex(kpis);
    let primaryKpi = appHelper.getArrayObjectByKey(kpis, "is_primary", true);
    if (isEven) {
        if (primaryIndex === 0) {
            return kpis;
        } else {
            kpis = dataHelper.immutableSplice(kpis, primaryIndex, 1);
            kpis = dataHelper.immutableUnshift(kpis, primaryKpi);
            return kpis;
        }
    } else {
        let centerIndex = Math.round(kpis.length / 2) - 1;

        if (primaryIndex === centerIndex) {
            return kpis;
        } else {
            kpis = dataHelper.immutableSplice(kpis, primaryIndex, 1);
            kpis = dataHelper.immutableSplice(kpis, centerIndex, 0, primaryKpi);
            return kpis;
        }
    }
}

export function getPrimaryKpiIndex(kpis) {

    for (let i = 0; i < kpis.length; i++) {
        let kpi = kpis[i];
        if (kpi.is_primary) {
            return i;
        }
    }
}

export function getBiteKpiTotalPoints(screens, kpi_id) {
    //console.log(`getBiteKpiTotalPoints : ${kpi_id}`);
    let totalPoints = 0;
    for (let i = 0; i < screens.length; i++) {
        //console.log(screens);
        if (appHelper.isDefined(screens[i].sub_screens)) {
            for (let s = 0; s < screens[i].sub_screens.length; s++) {
                let subScreen = screens[i].sub_screens[s];
                let subScreenObjects = subScreen.objects;
                let subScreenObjectPoints = getScreenObjectKpiTotalPoints(subScreenObjects, kpi_id);
                totalPoints = totalPoints + subScreenObjectPoints;
            }
        } else {
            let screenObjects = screens[i].objects;
            let screenObjectPoints = getScreenObjectKpiTotalPoints(screenObjects, kpi_id);
            totalPoints = totalPoints + screenObjectPoints;
        }
    }
    //console.log(`${kpi_id} totalPoints: ${totalPoints}`)
    return totalPoints;
}


function getScreenObjectKpiTotalPoints(screenObjects, kpi_id) {

    let screenObjectPoints = 0;
    for (let i = 0; i < screenObjects.length; i++) {
        if (appHelper.isDefined(screenObjects[i].options) && screenObjects[i].options.length) {
            let options = screenObjects[i].options;
            let optionPoints = 0;
            if (screenObjects[i].selection_type === objectConstants.SELECTION_TYPE_SELECT_ONE) {
                optionPoints = getObjectPoints(options, kpi_id);
               // console.log(kpi_id, `  ` ,optionPoints);
                screenObjectPoints = screenObjectPoints + optionPoints;
            } else {
                optionPoints = getObjectBestPoints(options, kpi_id);
                //console.log(kpi_id, `  ` ,optionPoints);
                screenObjectPoints = screenObjectPoints + optionPoints;
            }
            //console.log(`${kpi_id} screenObjectPoints: ${screenObjectPoints}`)
        }else if(appHelper.isDefined(screenObjects[i].assess_type) && screenObjects[i].assess_type === objectConstants.ASSESSED_TYPE_SCORED){
            //console.log('else');
            screenObjectPoints = screenObjectPoints + 2;
        }
    }

    return screenObjectPoints;
}

function getObjectPoints(options, kpi_id) {
    let optionPoints = 0;
    for (let i = 0; i < options.length; i++) {

        let option = options[i];
        if (option.kpis !== null && appHelper.isDefined(option.kpis) && option.kpis.length > 0) {
            let kpi = appHelper.getArrayObjectByKey(option.kpis, 'kpi_id', parseInt(kpi_id));

            if (appHelper.isDefined(kpi)) {
                if (kpi.value > optionPoints) {
                    optionPoints = kpi.value;
                }
            }
        }
    }
    //console.log(`optionPoints: ${optionPoints}`);
    return optionPoints;
}


export function getObjectBestPoints(options, kpi_id) {
    let optionPoints = 0;
    for (let i = 0; i < options.length; i++) {

        let option = options[i];
        //console.log(option);
        if (option.kpis !== null && appHelper.isDefined(option.kpis) && option.kpis.length > 0) {
            let kpi = appHelper.getArrayObjectByKey(option.kpis, 'kpi_id', parseInt(kpi_id));
            //console.log(`getObjectBestPoints`,option, kpi);
            if (appHelper.isDefined(kpi)) {
                if (option.result === objectConstants.RESULT_TYPE_BEST) {
                    optionPoints = parseInt(optionPoints) + parseInt(kpi.value);
                }
            }
        }
    }
    //console.log(`optionPoints: ${optionPoints}`);
    return optionPoints;
}

export function scaleKpiValue(kpiValue, options, kpi_id) {
    let max = getObjectBestPoints(options, kpi_id);
    let min = 0 - max;
    let percentageValue = dataHelper.getRangePercentage(min,max,kpiValue);
    if(percentageValue < 24){
        return -2;
    }else if(percentageValue > 24 && percentageValue < 50){
        return -1;
    }else if (percentageValue >= 50 && percentageValue < 75){
        return 0;
    }else if(percentageValue >= 75 && percentageValue < 100){
        return 1;

    }else{
        return 2;
    }


}



export function getKpiValue(kpiPointsVal, kpi) {
    //console.log(`(${kpiPointsVal} / ${kpi.totalPoints} * (${kpi.max} - ${kpi.start}))`);
    let decimals_points = parseInt(kpi.decimals_points) > 2 ? parseInt(kpi.decimals_points) : 2;
    //console.log(`(${kpiPointsVal} / ${kpi.totalPoints} * (${kpi.max} - ${kpi.start})).toFixed(${decimals_points}) = ${(kpiPointsVal / kpi.totalPoints * (kpi.max - kpi.start)).toFixed(decimals_points)}`);
    return (kpiPointsVal / kpi.totalPoints * (kpi.max - kpi.start)).toFixed(decimals_points);
}


export function getKpiScoreRange(kpi, value) {

    if (value < kpi.yellow) {
        return "poor";
    } else if (value >= kpi.yellow && value < kpi.green) {
        return "ok";
    } else {
        return "best";
    }
}


export function getResultKpiKey(kpi) {

    if (kpi.current < kpi.yellow) {
        return "red_feedback";
    } else if (kpi.current >= kpi.yellow && kpi.current < kpi.green) {
        return "yellow_feedback";
    } else {
        return "green_feedback";
    }
}

export function getKpiPreviousResultForObject(biteKpiHistory, screen_id, asset_id, kpi_id) {
    let currentAttempt = -1;
    let result = {};
    for (let i = 0; i < biteKpiHistory.length; i++) {
        let history = biteKpiHistory[i];
        if (history.screen_id === screen_id && history.asset_id === asset_id) {
            result = Object.assign({}, history);
        }
    }
    return result;
}

export function getKpiPreviousResultIndex(biteKpiHistory, screen_id, asset_id, kpi_id) {
    let currentAttempt = -1;
    let result = -1;
    for (let i = 0; i < biteKpiHistory.length; i++) {
        let history = biteKpiHistory[i];
        if (history.screen_id === screen_id && history.asset_id === asset_id) {
            result = i;
            currentAttempt = history.attempt;
        }
    }
    return result;
}


export function getKpiUserResponse(userKpiResult, screen_id, asset_id, option_id) {
    const kpi = userKpiResult.history.filter(kpi => kpi.screen_id == screen_id && (kpi.asset_id == asset_id && kpi.option_id == option_id));
    if (kpi) return kpi[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getKpiPointsIndicatorClass(value,kpi_id) {
    let kpi = getKpi(kpi_id);

    if(!appHelper.isDefined(kpi.scoring_pattern)){
        kpi = Object.assign({},kpi, {
            scoring_pattern: kpiModels.KPI_SCORING_PATTERNS[0]
        });
    }


    let indicatorClasses = appHelper.getArrayObjectByKey(kpiModels.KPI_SCORING_PATTERNS,"constant",kpi.scoring_pattern).indicatorClasses;
    let highestValue = appHelper.getArrayObjectByKey(indicatorClasses,"class","positive-double").value;
    let lowestValue = appHelper.getArrayObjectByKey(indicatorClasses,"class","negative-double").value;
    //console.log(`indicatorClass`,indicatorClasses,highestValue,lowestValue);

    let result = appHelper.getArrayObjectByKey(indicatorClasses, "value", value);
    if (!appHelper.isDefined(result)) {
        if (value > highestValue) {
            result = Object.assign({}, {
                value: value,
                class: "positive-double"
            });
        } else if (value < lowestValue) {
            result = Object.assign({}, {
                value: value,
                class: "negative-double"
            });
        }
    }

    return result;
}

function getKpi(kpi_id){
    for(let i = 0; i < localStorage.bites.length; i++){
        let bite = localStorage.bites[i];
        let kpis = getAllKpis(bite);
        if(kpis.length > 0){
            let kpiIndex = appHelper.getArrayObjectIndexByKey(kpis,"kpi_id",kpi_id);
            if(kpiIndex > -1){
               let kpi = appHelper.getArrayObjectByKey(kpis,"kpi_id",kpi_id);
               return kpi;
            }
        }
    }
}

export function getRotationAngle_old(maxRotation, currentPoints, totalPoints) {
    return (((maxRotation * 2) / totalPoints) * currentPoints) - maxRotation;
}

export function getRotationAngle(maxRotation, minValue, currentPoints, totalPoints) {
    let percentage = (currentPoints - minValue) / (totalPoints - minValue) * 100;
    let value = (totalPoints / 100) * percentage;
    return (((maxRotation * 2) / totalPoints) * value) - maxRotation;
}

export function describeArc(x, y, radius, startAngle, endAngle) {

    let start = polarToCartesian(x, y, radius, endAngle);
    let end = polarToCartesian(x, y, radius, startAngle);

    let largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

    let d = [
        "M", start.x, start.y,
        "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
    ].join(" ");

    return d;
}

function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    let angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

    return {
        x: centerX + (radius * Math.cos(angleInRadians)),
        y: centerY + (radius * Math.sin(angleInRadians))
    };
}

export function biteHasVisibleKpis(bite) {
    let visibleKpis = 0;
    if (appHelper.isDefined(bite.score_kpi) && bite.score_kpi.kpi_id !== null && bite.score_kpi.is_visible) {
        visibleKpis++;
    }

    if (appHelper.isDefined(bite.performance_kpis)) {
        _.forEach(bite.performance_kpis, function (kpi) {
            if (kpi.is_visible) {
                visibleKpis++;
            }
        });
    }

    return visibleKpis > 0;
}

export function kpisAreVisible(kpis,bite_id){
    let visibleKpis = 0;
    let bite = appHelper.getBiteById(bite_id);

    if (appHelper.isDefined(bite.score_kpi) && bite.score_kpi.kpi_id !== null && bite.score_kpi.is_visible) {
        if(appHelper.getArrayObjectIndexByKey(kpis,"kpi_id",bite.score_kpi.kpi_id) > -1){
            visibleKpis++;
        }
    }


    if (appHelper.isDefined(bite.performance_kpis)) {
        _.forEach(bite.performance_kpis, function (kpi) {
            if (kpi.is_visible && (appHelper.getArrayObjectIndexByKey(kpis,"kpi_id",kpi.kpi_id) > -1)) {
                visibleKpis++;
            }
        });
    }
    return visibleKpis > 0;
}

export function getKpis(bite) {
    let kpis = [];
    if (appHelper.isDefined(bite.score_kpi) && bite.score_kpi.is_visible) {
        let primaryKpi = Object.assign({}, bite.score_kpi, {
            is_primary: true
        });
        kpis = dataHelper.immutablePush(kpis, primaryKpi);
    }

    if (appHelper.isDefined(bite.performance_kpis)) {
        _.forEach(bite.performance_kpis, function (kpi) {
            if (kpi.is_visible) {
                kpi = Object.assign({}, kpi, {
                    is_primary: false
                });
                kpis = dataHelper.immutablePush(kpis, kpi);
            }
        });
    }
    return kpis;
}

export function getAllKpis(bite) {
    let kpis = [];
    if (appHelper.isDefined(bite.score_kpi)) {
        let primaryKpi = Object.assign({}, bite.score_kpi, {
            is_primary: true
        });
        kpis = dataHelper.immutablePush(kpis, primaryKpi);
    }

    if (appHelper.isDefined(bite.performance_kpis)) {
        _.forEach(bite.performance_kpis, function (kpi) {

                kpi = Object.assign({}, kpi, {
                    is_primary: false
                });
                kpis = dataHelper.immutablePush(kpis, kpi);

        });
    }
    return kpis;
}

export function getScoreKpi(bite) {
    let score_kpi = {};
    if (appHelper.isDefined(bite.score_kpi) && bite.score_kpi.is_visible) {
        score_kpi = Object.assign({}, bite.score_kpi, {
            is_primary: true
        });
    }
    return score_kpi;
}

export function averageKpis(responses) {
    let kpis = [];
    _.forEach(responses, function (response) {
        //console.log(response.kpis);
        _.forEach(response.kpis, function (kpi) {
            //console.log(kpis);
            let kpiIndex = appHelper.getArrayObjectIndexByKey(kpis, "kpi_id", kpi.kpi_id);
            let kpiResult = {};
            if (kpiIndex === -1) {
                kpiResult = Object.assign({}, kpiResult, {
                    kpi_id: kpi.kpi_id,
                    value: kpi.value
                });
                kpis = dataHelper.immutablePush(kpis, kpiResult);
            } else {
                kpiResult = Object.assign({}, kpis[kpiIndex], {
                    value: parseInt(kpi.value) + parseInt(kpis[kpiIndex].value)
                });
                kpis = dataHelper.immutableSplice(kpis, kpiIndex, 1, kpiResult);
            }
        });
    });
    /*
        _.forEach(kpis, function (kpi) {
            let kpiIndex = appHelper.getArrayObjectIndexByKey(kpis, "kpi_id", kpi.kpi_id);
            kpi = Object.assign({}, kpi, {
                value: Math.round(kpi.value / responses.length)
            });
            kpis = dataHelper.immutableSplice(kpis, kpiIndex, 1, kpi);
        });
    */
    return kpis;
}

export function removeObjectivesFromKpisToDisplay(kpiList) {
    let returnKpis = Object.assign([], kpiList);
    let trashCan = [];

    _.forEach(kpiList, function (kpi) {
        if (!kpi.data.is_primary) {
            trashCan = dataHelper.immutablePush(trashCan, kpi);
        }
    });

    _.forEach(trashCan, function (kpi) {
        let kpiIndex = appHelper.getArrayObjectIndexByKey(returnKpis, "kpi_id", kpi.kpi_id);
        returnKpis = dataHelper.immutableSplice(returnKpis, kpiIndex, 1);
    });

    return returnKpis;
}

export function removeScoreFromKpisToDisplay(kpiList) {
    let returnKpis = Object.assign([], kpiList);
    let trashCan = [];

    _.forEach(kpiList, function (kpi) {
        if (kpi.data.is_primary) {
            trashCan = dataHelper.immutablePush(trashCan, kpi);
        }
    });

    _.forEach(trashCan, function (kpi) {
        let kpiIndex = appHelper.getArrayObjectIndexByKey(returnKpis, "kpi_id", kpi.kpi_id);
        returnKpis = dataHelper.immutableSplice(returnKpis, kpiIndex, 1);
    });

    return returnKpis;
}

export function removeKpisFromKpisToDisplay(kpiList, kpisToRemove) {
    let returnKpis = Object.assign([], kpiList);
    let trashCan = [];

    _.forEach(kpiList, function (kpi) {
        _.forEach(kpisToRemove, function (kpiToRemove) {
            if (kpi.kpi_id === parseInt(kpiToRemove.kpi_id)) {
                trashCan = dataHelper.immutablePush(trashCan, kpi);
            }
        });
    });

    _.forEach(trashCan, function (kpi) {
        let kpiIndex = appHelper.getArrayObjectIndexByKey(returnKpis, "kpi_id", kpi.kpi_id);
        returnKpis = dataHelper.immutableSplice(returnKpis, kpiIndex, 1);
    });

    return returnKpis;
}

export function setKpiMenuData(kpiList) {

    let menuData = [];
    _.forEach(kpiList, function (kpi) {

        let menuItem = {
            constant: kpi.kpi_id,
            kpi_id: kpi.kpi_id,
            label: appHelper.getLocalData(kpi.data).long_title
        };
        menuData = dataHelper.immutablePush(menuData, menuItem);
    });
    return menuData;
}




/** WEBPACK FOOTER **
 ** ./src/helpers/kpiHelper.js
 **/